// @flow

const getSessionStorageKey = (pathname: string) =>
  pathname && typeof pathname === 'string' ? `session-resume:${pathname}` : '';

export default getSessionStorageKey;
